export type JudgementStatusType = 'Removed' | 'Submitted' | 'Draft';

export interface JudgementStatus {
  judgementId: number;
  nominationId: number;
  status: JudgementStatusType;
}

export function blankJudgementStatus(): JudgementStatus {
  return {
    judgementId: 0,
    nominationId: 0,
    status: 'Draft',
  };
}
